import React from 'react'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import {graphql} from 'react-apollo'
import {Trans} from 'react-i18next'

import messages from '../../../assets/messages'
import {FUND8_HOME_QUERY} from '../../../graphql/queries'
import {fund8Tiles, type Fund8HomeData} from './fund8Tiles'

type QueryData = {
  error?: unknown
  loading?: boolean
  viewer?: {fund8Home?: Fund8HomeData | null}
}

const label = (message: {defaults: string; i18nKey: string}) => <Trans {...message} />

/** Commission wallet and sponsor card on the current accounts home. */
export function Fund8TilesView({data}: {data?: QueryData}) {
  if (!data || data.loading || data.error) return null
  const tiles = fund8Tiles(data.viewer?.fund8Home)
  if (tiles == null) return null
  const cells = [
    {label: messages.fund8CommissionWallet, value: `${tiles.wallet} USD`},
    {label: messages.fund8Nft, value: tiles.nft},
    {label: messages.fund8Sponsor, value: tiles.sponsor},
    {label: messages.fund8MasterIb, value: tiles.master},
  ]
  return (
    <Grid item xs={12}>
      <Grid container spacing={2}>
        {cells.map((cell) => (
          <Grid item key={cell.label.i18nKey} xs={6} sm={3}>
            <Typography variant="caption" color="textSecondary">
              {label(cell.label)}
            </Typography>
            <Typography variant="h6">{cell.value}</Typography>
          </Grid>
        ))}
      </Grid>
      {tiles.lines.length > 0 ? (
        <>
          <Typography variant="caption" color="textSecondary">
            {label(messages.fund8Network)}
          </Typography>
          <ul>
            {tiles.lines.map((line) => (
              <li key={line}>{line}</li>
            ))}
          </ul>
        </>
      ) : null}
    </Grid>
  )
}

export const Fund8Tiles = graphql<{enabled?: boolean}, QueryData>(FUND8_HOME_QUERY, {
  options: () => ({errorPolicy: 'ignore', fetchPolicy: 'cache-first'}),
  skip: ({enabled}) => !enabled,
})(Fund8TilesView)
